"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigState = exports.ConfigProvider = exports.ConfigContext = void 0;
var react_1 = __importDefault(require("react"));
var config_service_1 = require("../../services/config.service");
/**
 * getConfigState
 * @description gets the config state
 * @returns a config state
 */
var getConfigState = function () { return ({
    service: new config_service_1.ConfigService(),
}); };
exports.getConfigState = getConfigState;
// config context
var ConfigContext = react_1.default.createContext(null);
exports.ConfigContext = ConfigContext;
// setup context provider wrapper
var ConfigProvider = function (props) {
    var _a;
    var state = (_a = props.state) !== null && _a !== void 0 ? _a : getConfigState();
    return (react_1.default.createElement(ConfigContext.Provider, { value: state }, props.children));
};
exports.ConfigProvider = ConfigProvider;
